import React from 'react';
import { SelectedDossierProvider } from '@europrocurement/l2d-modules';
import DossierInfoValidation from './DossierInfoValidation';

const InfoValidation: React.FunctionComponent = function () {
    return (
        <SelectedDossierProvider>
            <DossierInfoValidation />
        </SelectedDossierProvider>
    );
};

export default InfoValidation;
